import { ThemeProvider } from 'styled-components'
import { BrowserRouter, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

import registerIcons from 'utils/fortawesome'
import ErrorBoundary from 'modules/ErrorBoundary'
import theme from './theme'
import AppSetup from './AppSetup'
import GlobalStyles from './styles'
import AppContext from './AppContext'
import QueryProvider from './QueryProvider'
import { DialerClientProvider } from 'modules/DialerClient/DialerClientContext'
import { DialerUIProvider } from 'modules/DialerClient/DialerUIContext'
import { DialerSocketProvider } from 'modules/DialerClient/DialerSocketContext'
import { setNavigator } from 'utils/history'

registerIcons()

const NavigationHandler = () => {
  const nav = useNavigate()
  useEffect(() => {
    setNavigator(nav)
  }, [nav])
  return null
}

const App = () => {
  const isTokenPresent = !!localStorage.getItem('token')

  return (
    <ThemeProvider theme={theme}>
      <ErrorBoundary hasToken={isTokenPresent}>
        <QueryProvider>
          <BrowserRouter>
            <NavigationHandler />
            <DialerUIProvider>
              <DialerSocketProvider>
                <DialerClientProvider>
                  <AppContext>
                    <AppSetup />
                    <GlobalStyles />
                  </AppContext>
                </DialerClientProvider>
              </DialerSocketProvider>
            </DialerUIProvider>
          </BrowserRouter>
        </QueryProvider>
      </ErrorBoundary>
    </ThemeProvider>
  )
}

export default App
